import { faWarning } from '@fortawesome/pro-solid-svg-icons';
import { Button, InfoBox, Modal, ModalCloseButton, NotificationDispatch } from '@tryhackme/thm-ui-components';
import { useEffect, useState } from 'react';
import { isQueryErrorWithMessage } from 'src/common/helpers/slices';
import { useLazyResetPasswordQuery } from 'src/features/admin/manage-users/manage-users.slice';
import { StyledActionButtonsWrapper, StyledContent, StyledFontAwesomeWarningIcon, StyledText, StyledTitle, StyledWarningToast, StyledWrapper } from 'src/features/admin/manage-users/modals/modals.styles';
import { StyledResetPasswordLink } from 'src/features/admin/manage-users/modals/reset-password/reset-password-modal.styles';
import type { ModalProps } from '../modal.types';
export const ModalResetPassword = ({
  userId,
  triggerElement,
  isOpen,
  setIsOpen
}: ModalProps) => {
  const [resetPasswordLink, setResetPasswordLink] = useState<string>('');
  const [tooltipVisible, setTooltipVisible] = useState(false);
  const [resetPassword] = useLazyResetPasswordQuery();
  useEffect(() => {
    if (tooltipVisible) {
      setTimeout(() => {
        setTooltipVisible(false);
      }, 1600);
    }
  }, [tooltipVisible]);
  const onOpenChange = () => {
    setIsOpen(!isOpen);
    setResetPasswordLink('');
  };
  const onGenerateLink = async () => {
    try {
      const {
        data
      } = await resetPassword({
        userId
      }).unwrap();
      setResetPasswordLink(data?.resetLink ?? '');
    } catch (error: unknown) {
      NotificationDispatch('error', isQueryErrorWithMessage(error) ? error.data.message : 'An unknown error has occurred');
    }
  };
  return <Modal open={isOpen} isSmall triggerElement={triggerElement} onOpenChange={onOpenChange} data-sentry-element="Modal" data-sentry-component="ModalResetPassword" data-sentry-source-file="reset-password-modal.tsx">
      <StyledWrapper data-sentry-element="StyledWrapper" data-sentry-source-file="reset-password-modal.tsx">
        <StyledTitle data-sentry-element="StyledTitle" data-sentry-source-file="reset-password-modal.tsx">Reset password</StyledTitle>
        <StyledContent data-sentry-element="StyledContent" data-sentry-source-file="reset-password-modal.tsx">
          <StyledText data-sentry-element="StyledText" data-sentry-source-file="reset-password-modal.tsx">Click on &quot;Generate link&quot; to get a reset password link for this user.</StyledText>
          {!!resetPasswordLink && <InfoBox textToCopy={resetPasswordLink} linkButtonType="icon">
              <StyledResetPasswordLink>{resetPasswordLink}</StyledResetPasswordLink>
            </InfoBox>}
          <StyledWarningToast data-sentry-element="StyledWarningToast" data-sentry-source-file="reset-password-modal.tsx">
            <StyledFontAwesomeWarningIcon icon={faWarning} data-sentry-element="StyledFontAwesomeWarningIcon" data-sentry-source-file="reset-password-modal.tsx" />
            The link will only be valid for 2 hours.
          </StyledWarningToast>
        </StyledContent>
        <StyledActionButtonsWrapper data-sentry-element="StyledActionButtonsWrapper" data-sentry-source-file="reset-password-modal.tsx">
          <ModalCloseButton text="Cancel" data-sentry-element="ModalCloseButton" data-sentry-source-file="reset-password-modal.tsx" />
          {/* eslint-disable-next-line @typescript-eslint/no-misused-promises */}
          <Button onClick={onGenerateLink} variant="solid" color="primary" data-sentry-element="Button" data-sentry-source-file="reset-password-modal.tsx">
            Generate link
          </Button>
        </StyledActionButtonsWrapper>
      </StyledWrapper>
    </Modal>;
};